var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nuxt-picture',{attrs:{"src":"/logos/logo-myhausheld.svg","width":_vm.width,"height":_vm.height,"alt":_vm.$t('images.logo')}})
}
var staticRenderFns = []

export { render, staticRenderFns }